import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface IContainer {
  offsetTop: number;
}

export const Container = styled.div<IContainer>`
  --offset-top: ${({ offsetTop }) => offsetTop}px;

  padding: 16px 24px 24px 24px;
  min-height: calc(100vh - var(--offset-top));
  background: #fcfeff;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
export const Text = styled(WarningText)`
  color: ${beam.font.primary};
  width: fit-content;
  white-space: nowrap;
  margin-left: 8px;
`;
export const ButtonText = styled(WarningText)`
  color: ${beam.font.link};
  margin-left: 14px;
  cursor: pointer;
`;
export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;
export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  :disabled {
    opacity: 0.3;
  }
`;
export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
`;

export const Search = styled.input`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  width: 429px;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: #787878;
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Count = styled.div`
  color: #1a1b1c;
  margin-left: 16px;
`;
export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 6px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;
